import { Checkbox, Form, InputPicker, Schema } from 'rsuite';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import { PatternFormat } from 'react-number-format';
import { getStates, getFirmTypes } from '../../../services/Shared/codeTable.service';
import AuthService from "../../../services/auth.service";
import PhoneNumberMask from '../../Shared/GenericComponents/PhoneNumberMask';
import { AccessibleInputPicker } from '../../Shared/GenericComponents/AccessibleComponents';


const InputMask = ({ onChange, ...rest }) => {
    return (
        <PatternFormat
            {...rest}
            className="form-control"
            onChange={event => {
                onChange(event.target.value);
            }}
        />
    );
};
function FirmForm() {
    const [showPass, toggleShowPass] = useState(false);
    const history = useNavigate();
    const [states, setStates] = useState([]);
    const [firmTypes, setFirmTypes] = useState([]);
    const [inputType, setInputType] = useState("text");
    const [hasLoaded, setHasLoaded] = useState(false);
    useEffect(() => {
        getStates().then(setStates);
        getFirmTypes().then(setFirmTypes);
        setHasLoaded(true)
    }, [])
    const { StringType, DateType, ObjectType } = Schema.Types;
    const model = Schema.Model({
        fein: StringType().isRequired('This field is required.').pattern(/^[0-9]{2}-[0-9]{7}$/, "Please enter a vaild FEIN"),
        userName: StringType().addRule((value, data) => {
            //return AuthService.checkUsername(value).then((response) => {
            //    return response.data;//assuming this is a bool value
            //})
            return true;
        }, 'This username is already in use').addRule((value, data) => {
            var alphaNumeric = /^[0-9a-zA-Z]+$/;
            if (value.match(alphaNumeric))
                return true;
            else {
                return false;
            }
        }, "Invalid characters in username. Please use numbers or letters only.").isRequired('This field is required.'),
        email: StringType().isRequired('This field is required.').isEmail("This is not a valid Email."),
        confirmEmail: StringType().isRequired('This field is required.').addRule((value, data) => {
            if (value !== data.email) {
                return false;
            }
            return true;
        }, "Emails don't match").isEmail("This is not a valid Email."),
        password: StringType().pattern(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{8,}$/, 'Password requires a minimum of 8 characters using upper and lower case letters, and at least 1 number and 1 symbol').isRequired('This field is required.'),
        confirmPassword: StringType().isRequired('This field is required.').addRule((value, data) => {
            if (value !== data.password) {
                return false;
            }
            return true;
        }, "Passwords don't match"),
        firmName: StringType().isRequired("This field is required."),
        domicileState: ObjectType().isRequired("This field is required."),
        firmType: ObjectType().isRequired("This field is required."),
        formationDate: DateType().isRequired("This field is required."),
        contactName: StringType().isRequired("This field is required."),
        website: StringType().isURL("Please enter a valid URL (http://google.com)"),
        phone: StringType().isRequired('This field is required.').pattern(/^([(]\d{3}[)][ ]\d{3}[-]\d{4})|[0-9]{10}/, "Please enter a valid Phone Number"),

    })
    const [state, setState] = useState({
        firmName: "",
        fein: "",
        contactName: "",
        website: "",
        email: "",
        confirmEmail: "",
        firmType: "",
        domicileState: "",
        formationDate: "",
        password: "",
        confirmPassword: "",
        userName: "",
        phone: ""
    });
    const handleFirmFormSubmit = (validation, event) => {
        var validationObject = model.check(state);
        for (const key in validationObject) {
            if (validationObject[key].hasError) {
                return;
            }
        }
        var dataToTransmit = {
            ...state,
            phone: { ...state.phone, phoneNumber: state.phone == '' ? null : state.phone }
        };
        AuthService.registerFirm(dataToTransmit).then(
            (data) => {
                if (data.data.isSuccess) {
                    history("/registerSuccess");
                }
            },
            (error) => {
                const resMessage =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();
                alert(resMessage);
            }
        );
    }
    return (
        <Form id="firmForm" fluid formValue={state} model={model} onChange={setState} onSubmit={handleFirmFormSubmit}>
            <Row className="mb-4 pb-1">
                <Col>
                    <Form.Group>
                        <Form.ControlLabel className='d-none'>Firm Name</Form.ControlLabel>
                        <Form.Control name="firmName" placeholder="Firm Name" />
                        <Form.HelpText className='d-none'>Enter a firm name</Form.HelpText>
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.ControlLabel className='d-none'>Contact Name</Form.ControlLabel>
                        <Form.Control name="contactName" placeholder="Contact name" />
                        <Form.HelpText className='d-none'>Enter a contact name</Form.HelpText>
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.ControlLabel className='d-none'>Email</Form.ControlLabel>
                        <Form.Control name="email" placeholder="Company Email" checkTrigger="blur" />
                        <Form.HelpText className='d-none'>Enter a company email</Form.HelpText>
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-4 pb-1">
                <Col>
                    <Form.Group>
                        <Form.ControlLabel className='d-none'>FEIN</Form.ControlLabel>
                        <Form.Control
                            accepter={InputMask}
                            placeholder="FEIN"
                            name="fein"
                            format="##-#######"
                            mask="_" />
                        <Form.HelpText className='d-none'>Enter a FEIN</Form.HelpText>
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.ControlLabel className='d-none'>Website</Form.ControlLabel>
                        <Form.Control name="website" placeholder="Website" />
                        <Form.HelpText className='d-none'>Enter a website url. This is not required</Form.HelpText>
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.ControlLabel className='d-none'>Confirm Email</Form.ControlLabel>
                        <Form.Control
                            name="confirmEmail"
                            placeholder="Confirm Company Email"
                            checkTrigger="blur" />
                        <Form.HelpText className='d-none'>Confirm company email</Form.HelpText>
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-4 pb-1">
                <Col>
                    <Form.Group>
                        <Form.ControlLabel className='d-none'>Firm Type</Form.ControlLabel>
                        <Form.Control
                            block
                            name="firmType"
                            placeholder="Select a Firm Type"
                            accepter={AccessibleInputPicker}
                            ariaLabel="Firm Type"
                            data={firmTypes} />
                        <Form.HelpText className='d-none'>Select a firm type</Form.HelpText>
                    </Form.Group>

                </Col>
                <Col>
                    <Form.Group>
                        <Form.ControlLabel className='d-none'>Domicile State</Form.ControlLabel>
                        <Form.Control
                            block
                            name="domicileState"
                            placeholder="Select Firm Domicile State"
                            searchBy={(userInput, label, dataItem) => { if (label.toLowerCase().startsWith(userInput.toLowerCase()) || !userInput) return true; }}
                            accepter={AccessibleInputPicker}
                            ariaLabel="Firm Domicile State"
                            data={states} />
                        <Form.HelpText className='d-none'>Select a domicile state</Form.HelpText>
                    </Form.Group>

                </Col>
                <Col>
                    <Form.Group>
                        <Form.ControlLabel className='d-none'>Date Firm Formed</Form.ControlLabel>
                        <Form.Control
                            type={inputType}
                            name="formationDate"
                            onFocus={() => setInputType("date")}
                            onBlur={(e) => { if (!e.target.value) { setInputType("text") } }}
                            placeholder="Date Formed / Incorporated" />
                        <Form.HelpText className='d-none'>Enter the date when the firm was formed</Form.HelpText>
                    </Form.Group>

                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Group>

                        <Form.ControlLabel className='d-none'>Phone</Form.ControlLabel>
                        <Form.Control
                            accepter={PhoneNumberMask}
                            placeholder="Enter a phone"
                            name="phone"
                            format="(###) ###-####x#####"
                            mask="_" />
                        <Form.HelpText className='d-none'>Enter a phone number</Form.HelpText>
                    </Form.Group>

                </Col>
                <Col>
                </Col>
                <Col>
                </Col>
            </Row>
            <br />
            <hr />
            <Row>
                <Col>
                    <Form.Group>
                        <Form.ControlLabel className='d-none'>User Name</Form.ControlLabel>
                        <Form.Control placeholder="User Id" name="userName" errorPlacement="topStart" />
                        <Form.HelpText className='d-none'>Enter a user name</Form.HelpText>
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.ControlLabel className='d-none'>Password</Form.ControlLabel>
                        <Form.Control
                            type={showPass ? "text" : "password"}
                            placeholder="Password"
                            checkTrigger="blur"
                            name="password"
                            title="Password requires a minimum of 8 characters using upper and lower case letters, and at least 1 number and 1 symbol"
                            errorPlacement="topStart" />
                        <Form.HelpText className='d-none'>Enter a password</Form.HelpText>
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.ControlLabel className='d-none'>Confirm Password</Form.ControlLabel>
                        <Form.Control
                            type={showPass ? "text" : "password"}
                            placeholder="Confirm Password"
                            checkTrigger="blur"
                            name="confirmPassword"
                            errorPlacement="bottomStart" />
                        <Form.HelpText className='d-none'>Confirm password</Form.HelpText>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col></Col>
                <Col>
                    <Checkbox onChange={() => { toggleShowPass(!showPass) }} >Show Password</Checkbox>
                </Col>
                <Col></Col>
            </Row>
        </Form>
    );
}
export default FirmForm;